(function () {
  'use strict';

  // Scroll reveal
  var items = document.querySelectorAll('[data-reveal]');
  if ('IntersectionObserver' in window && items.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('in');
          io.unobserve(e.target);
          var vids = e.target.querySelectorAll('video[autoplay]');
          vids.forEach(function (v) {
            var p = v.play();
            if (p && p.catch) p.catch(function () {});
          });
        }
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.08 });
    items.forEach(function (el) { io.observe(el); });
  } else {
    items.forEach(function (el) { el.classList.add('in'); });
  }

  // Belt-and-suspenders: nudge any autoplay video to play once it can,
  // and once more on first user interaction in case the browser blocked
  // programmatic autoplay before then.
  var allVideos = document.querySelectorAll('video[autoplay]');
  if (allVideos.length) {
    var kick = function () {
      allVideos.forEach(function (v) {
        if (v.paused) {
          var p = v.play();
          if (p && p.catch) p.catch(function () {});
        }
      });
    };
    ['pointerdown', 'touchstart', 'scroll'].forEach(function (evt) {
      window.addEventListener(evt, kick, { passive: true, once: true });
    });
  }

  // Header: transparent over a hero, solid once scrolled
  var hdr = document.querySelector('[data-hdr]');
  if (hdr) {
    var onScroll = function () {
      hdr.classList.toggle('is-stuck', window.scrollY > 40);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  // Mobile menu
  var burger = document.querySelector('[data-burger]');
  var menu = document.querySelector('[data-mobmenu]');
  if (burger && menu && hdr) {
    burger.addEventListener('click', function () {
      var open = hdr.classList.toggle('is-open');
      menu.classList.toggle('is-open', open);
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.body.style.overflow = open ? 'hidden' : '';
    });
    menu.addEventListener('click', function (e) {
      if (e.target.closest('a')) {
        hdr.classList.remove('is-open');
        menu.classList.remove('is-open');
        document.body.style.overflow = '';
      }
    });
  }

  // Subtle parallax on hero media (desktop only — the mobile layout below
  // 721px makes .hero__media a static, unclipped block, so applying the
  // same translate3d/scale transform there stretched and smeared the image
  // and cut off the top of the photo as the page scrolled).
  var pm = document.querySelector('[data-parallax]');
  if (pm && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    var raf = null;
    var pmq = window.matchMedia('(min-width: 721px)');
    var resetParallax = function () {
      if (!pmq.matches) pm.style.transform = '';
    };
    window.addEventListener('scroll', function () {
      if (!pmq.matches) return;
      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = null;
        var y = window.scrollY;
        if (y < window.innerHeight * 1.2) pm.style.transform = 'translate3d(0,' + (y * 0.14).toFixed(1) + 'px,0) scale(1.06)';
      });
    }, { passive: true });
    if (pmq.addEventListener) pmq.addEventListener('change', resetParallax);
    else if (pmq.addListener) pmq.addListener(resetParallax);
    resetParallax();
  }
})();
